<div class=" m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
  <router-outlet></router-outlet>
</div>
